import styled, { css } from 'styled-components';

export const Content = styled.div``;

export const Middle = styled.div`
  width: 20px;
  height: 20px;
  background: #aaa;
  margin: 0 0.5rem 0 0;
`;

export const Name = styled.div`
  margin: 0 0 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
  /* padding: 5px; */
  /* border: 1px solid #ccc; */
  /* border-radius: 5px; */
  input {
    width: 20px;
    height: 20px;
    accent-color: #aaa;
  }
`;

export const Items = styled.div`
  input {
    cursor: pointer;
    margin: 0 0.5rem 0 0;
  }
  label {
    cursor: pointer;
    display: flex;
    font-weight: normal;
    align-items: center;
    margin: 0 0 5px;
    flex-grow: 0;
    input {
      width: 20px;
      height: 20px;
    }
    ::first-letter {
      text-transform: capitalize;
    }
  }

  &.sub {
    padding: 3px 0 4px 27px;
  }
`;
